import * as THREE from 'three';

/**
 * Closed cutter profile for the recessed grip. The curved return reaches the
 * pocket floor at local X=0; only the following flat segment enters the broad
 * pocket. This keeps the visible curve tangent to the floor while preserving a
 * generous overlap between both CSG cutters.
 */
export function createHandleProfile(
  profileWidth: number,
  cutDepth: number,
  frontZ: number,
  frontEpsilon: number,
  segments: number,
) {
  const front = frontZ + frontEpsilon;
  const pocketFloor = frontZ - cutDepth - frontEpsilon;
  const start = new THREE.Vector2(0, front);
  const undercut = new THREE.Vector2(-profileWidth * 0.84, frontZ - cutDepth * 0.5);
  const pocketJoin = new THREE.Vector2(0, pocketFloor);
  const pocketOverlapX = profileWidth * 0.34;
  const profile = [start];

  appendCubicPoints(
    profile,
    start,
    new THREE.Vector2(-profileWidth * 0.08, frontZ - cutDepth * 0.08),
    new THREE.Vector2(-profileWidth * 0.8, frontZ - cutDepth * 0.24),
    undercut,
    segments,
  );
  appendCubicPoints(
    profile,
    undercut,
    new THREE.Vector2(-profileWidth * 0.9, frontZ - cutDepth * 0.78),
    new THREE.Vector2(-profileWidth * 0.3, pocketFloor),
    pocketJoin,
    segments,
  );
  profile.push(
    new THREE.Vector2(pocketOverlapX, pocketFloor),
    new THREE.Vector2(pocketOverlapX, front),
  );
  return profile;
}

function appendCubicPoints(
  target: THREE.Vector2[],
  start: THREE.Vector2,
  controlA: THREE.Vector2,
  controlB: THREE.Vector2,
  end: THREE.Vector2,
  segments: number,
) {
  for (let index = 1; index <= segments; index += 1) {
    const t = index / segments;
    const inverse = 1 - t;
    target.push(
      new THREE.Vector2(
        inverse ** 3 * start.x +
          3 * inverse ** 2 * t * controlA.x +
          3 * inverse * t ** 2 * controlB.x +
          t ** 3 * end.x,
        inverse ** 3 * start.y +
          3 * inverse ** 2 * t * controlA.y +
          3 * inverse * t ** 2 * controlB.y +
          t ** 3 * end.y,
      ),
    );
  }
}
